<template>
    <span class="aptTime">
        <span v-if="showEditor">
            <div style="display: flex">
                <span @click="openDatePicker()">
                    <DatePicker placeholder="Choose date" v-model="date" format="MMM dd, yyyy"></DatePicker>
                </span>
                <v-select class="time-picker" :options="hours" valueKey="value" textKey="text" :currentValue="time" @change="time = $event" :allowUnset="true"></v-select>
                <button style="margin-top: 0; margin-left: 2px" @click="done">
                    <i class="fa fa-check"></i>
                </button>
            </div>
        </span>
        <span v-else @click="toggleEdit()" class="notEditingDisplay">
            <template v-if="currentValue">{{toText}}</template>
        </span>
    </span>
</template>

<script>
    import DatePicker from 'vuejs-datepicker'
    import epoch from 'epoch.js'
    import moment from 'moment'

    window.moment = moment

    const isToday = (date) => {
        return moment(date).startOf('day').valueOf() === moment().startOf('day').valueOf()
    }

    const isTomorrow = (date) => {
        return moment(date).startOf('day').valueOf() === moment().add(1, 'days').startOf('day').valueOf()
    }

    export default {
        components: {
            DatePicker
        },
        data () {
            return {
                editing: false,
                modified: false,
                date: '',
                time: ''
            };
        },
        props: [
            'currentValue',
            'readonly',
            'editonly',
            'hidedate'
        ],
        mounted() {
            console.log("APPT TIME MOUNTED WITH VALUE OF " + JSON.stringify(this.currentValue));
            if(this.currentValue && moment(this.currentValue).isValid()) {
                this.date = moment(this.currentValue).startOf('day').format('YYYY-MM-DD')
                this.time = moment(this.currentValue).format('HH:mm:ss')
            }
        },
        computed: {
            newValue () {
                if (this.date && this.time) {
                    return moment(this.date).format('YYYY-MM-DD') + ' ' + this.time;
                } 
                else {
                    return null;
                }
            },
            toText () {
                if(this.newValue) {
                    let datepart = isToday(this.date) ? (this.hidedate !== undefined ?  ''  : 'Today')  : (isTomorrow(this.date) ? 'Tomorrow' : moment(this.date).format('MM/DD'));
                    
                    return datepart + ' ' + moment(this.newValue, 'YYYY-MM-DD hh:mm:ss').format('h:mmA');
                }
                else {
                    return '';
                }
            },
            showEditor () {
                return ((this.readonly === undefined) && (this.editing || this.editonly !== undefined));
            },
            hours () {
                let hours = [];
                
                for (let h = 9; h < 21; h++) {
                    for (let M = 0; M < 6; M++) {
                        for (let m = 0; m < 10; m += 5) {
                            let am = h < 12;
                            let weirdH = am ? h : h - 12;

                            weirdH = weirdH === 0 ? 12 : weirdH;
                            hours.push({
                                text: `${weirdH}:${M}${m}${am ? 'am' : 'pm'}`,
                                value: `${Math.floor(h/10)}${h % 10}:${M}${m}:00`
                            });
                        }
                    }
                }

                  return hours;
            }
        },
        watch: {
            newValue (newDateTime, oldDateTime) {
                console.log("NEW DATE TIME " + newDateTime + " OLD DATE TIME " + oldDateTime);
                if (newDateTime != oldDateTime) {
                    console.log("modified to " + this.newValue);
                    this.modified = true;
                }
            }
        },
        methods: {
            toggleEdit () {
                if (this.readonly !== undefined) {
                    this.editing = false;
                } 
                else {
                    this.editing = true;
                }
            },
            done () {
                this.$emit('change', epoch(this.newValue).datetime());
                this.modified = false;
                this.editing = false;
            },
            openDatePicker () {
                if (this.date === '') {
                    this.date = new Date();
                }
            },
        },
    }
</script>

<style lang="less">
    .appt_time {
        display: inline-block;
    }

    .date-picker {
        margin-right: 1em;
    }

    .time-picker {
        width: 8em;
    }

    .notEditingDisplay {
        cursor: pointer;
    }
</style>